import AppContainer from '../basicLayout/AppContainer';
export default [
  {
    path: '/mobileVersion',
    name: 'mobile_version',
    component: AppContainer,
    meta: {
      title: '应用管理',
    },
    children: [
      {
        path: 'mobileVersionList',
        meta: {
          title: '版本管理',
        },
        name: 'MobileVersionList',
        component: (resolve) =>
          require(['@/views/mobile/app/version/index.vue'], resolve),
      },
      {
        path: 'mobilePermission',
        meta: {
          title: '权限管理',
        },
        name: 'MobilePermission',
        component: (resolve) =>
          require(['@/views/mobile/app/permission/index.vue'], resolve),
      },
        {
        path: 'mobileRolePermission',
        meta: {
          title: '角色权限',
        },
        name: 'MobileRolePermission',
        component: (resolve) =>
          require(['@/views/mobile/app/rolePermissions/index.vue'], resolve),
      },
    ],
  },
  {
    path: '/mobileSys',
    name: 'mobile_sys_management',
    component: AppContainer,
    meta: {
      title: '系统管理',
    },
    children: [
      {
        path: 'mobileDept',
        name: 'MobileDept',
        meta: {
          title: '部门管理',
        },
        component: (resolve) =>
          require(['@/views/mobile/sys/org/index.vue'], resolve),
      },
      {
        path: 'mobilePost',
        meta: {
          title: '岗位管理',
        },
        name: 'MobilePost',
        component: (resolve) =>
          require(['@/views/mobile/sys/post/index.vue'], resolve),
      },
      {
        path: 'mobileRole',
        meta: {
          title: '角色管理',
        },
        name: 'MobileRole',
        component: (resolve) =>
          require(['@/views/mobile/sys/role/index.vue'], resolve),
      },

      {
        path: 'mobileUser',
        meta: {
          title: '用户管理',
        },
        name: 'MobileUser',
        component: (resolve) =>
          require(['@/views/mobile/sys/user/index.vue'], resolve),
      }, 
      {
        path: 'mobileDict',
        meta: {
          title: '字典管理',
        },
        name: 'MobileDict',
        component: (resolve) =>
          require(['@/views/mobile/sys/dict/index.vue'], resolve),
      },
    ],
  },
];
